// Produktet Baby tani ruhen në Supabase database
export const productsBaby = [];
